import React from "react";
import { motion } from "framer-motion";
import { MapPin, Phone, Mail, MessageCircle, Quote } from "lucide-react";
import { BIZ, CLIENT_REVIEWS } from "./psoData";
import PsoLayout, { NAVY, EMERALD, CREAM, SLATE } from "./PsoLayout";
import AccountingInquiryForm from "@/components/AccountingInquiryForm";

const fadeUp = { initial: { opacity: 0, y: 20 }, whileInView: { opacity: 1, y: 0 }, viewport: { once: true, margin: "-60px" }, transition: { duration: 0.5, ease: "easeOut" } };

export default function PsoContact() {
  return (
    <PsoLayout active="contact">
      <section className="py-16 sm:py-20" style={{ background: NAVY }}>
        <div className="max-w-3xl mx-auto px-5 sm:px-8 text-center">
          <motion.span {...fadeUp} className="text-xs uppercase tracking-[0.25em] font-semibold" style={{ color: "#6EE7B7" }}>Contact</motion.span>
          <motion.h1 {...fadeUp} className="mt-4 text-3xl sm:text-5xl font-extrabold text-white">Makati Office</motion.h1>
        </div>
      </section>

      {/* CLIENT FEEDBACK — client-oriented reviews only */}
      <section className="py-14" style={{ background: CREAM }}>
        <div className="max-w-4xl mx-auto px-5 sm:px-8">
          <motion.h2 {...fadeUp} className="text-xl font-bold text-center mb-8" style={{ color: NAVY }}>Client Feedback</motion.h2>
          <div className="grid sm:grid-cols-2 gap-5">
            {CLIENT_REVIEWS.map((r) => (
              <motion.div key={r.author} {...fadeUp} className="bg-white rounded-lg p-5 shadow-sm">
                <Quote size={16} style={{ color: EMERALD }} className="mb-2" />
                <p className="text-xs" style={{ color: NAVY }}>"{r.quote}"</p>
                <p className="mt-2 text-[11px]" style={{ color: SLATE }}>— {r.author}, {r.source}, {r.date}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16" style={{ background: "white" }}>
        <div className="max-w-6xl mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-10">
          <motion.div {...fadeUp}>
            <h2 className="text-2xl font-extrabold mb-6" style={{ color: NAVY }}>Get in Touch</h2>
            <ul className="space-y-4 text-sm mb-6">
              <li className="flex items-start gap-3"><MapPin size={18} style={{ color: EMERALD }} className="mt-0.5 shrink-0" />{BIZ.address}</li>
              <li className="flex items-start gap-3"><Phone size={18} style={{ color: EMERALD }} className="mt-0.5 shrink-0" /><a href={`tel:${BIZ.phone}`} data-testid="pso-phone-link" className="hover:underline">{BIZ.phoneDisplay}</a> / {BIZ.landline}</li>
              <li className="flex items-start gap-3"><MessageCircle size={18} style={{ color: EMERALD }} className="mt-0.5 shrink-0" />WhatsApp: {BIZ.whatsapp}</li>
              <li className="flex items-start gap-3"><Mail size={18} style={{ color: EMERALD }} className="mt-0.5 shrink-0" /><a href={`mailto:${BIZ.email}`} data-testid="pso-email-link" className="hover:underline">{BIZ.email}</a></li>
            </ul>
            <div className="rounded-lg overflow-hidden shadow-sm min-h-[220px]">
              <iframe title="PSO Accounting Group map" src={BIZ.mapEmbed} className="w-full h-full min-h-[220px]" style={{ border: 0 }} loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
            </div>
          </motion.div>
          <motion.div {...fadeUp}>
            <AccountingInquiryForm
              testidPrefix="pso"
              businessName={BIZ.name}
              accent={EMERALD}
              accentText="#FFFFFF"
              phone={BIZ.phone}
              phoneDisplay={BIZ.phoneDisplay}
              email={BIZ.email}
              messengerUrl={BIZ.facebook}
            />
          </motion.div>
        </div>
      </section>
    </PsoLayout>
  );
}
